import {
  STOCK_BUCKET_LABELS,
  STOCK_REFERENCE_TYPE_LABELS,
  type StockCardEntry,
} from "@artisancode/api-types";

/** Human labels for a ledger entry: what caused it and which buckets it moved between. */
export function describeStockCardEntry(entry: StockCardEntry) {
  return {
    refLabel: entry.referenceType
      ? STOCK_REFERENCE_TYPE_LABELS[entry.referenceType] || entry.referenceType
      : "-",
    fromLabel: entry.bucketFrom
      ? STOCK_BUCKET_LABELS[entry.bucketFrom]
      : "Luar Toko",
    toLabel: entry.bucketTo
      ? STOCK_BUCKET_LABELS[entry.bucketTo]
      : "Keluar / Terpakai",
    /** A bucket-to-bucket transfer: no net in/out, only `qty` moved. */
    isTransfer:
      !!entry.bucketFrom &&
      !!entry.bucketTo &&
      entry.qtyIn === 0 &&
      entry.qtyOut === 0,
  };
}

export const STOCK_CARD_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  dateStyle: "medium",
  timeStyle: "short",
};
